import script from "./TestimonialsBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./TestimonialsBlock.vue?vue&type=script&setup=true&lang=js"

import "./TestimonialsBlock.vue?vue&type=style&index=0&id=51c4d2a2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51c4d2a2"]])

export default __exports__